import {
  ExpandMore as ExpandMoreIcon,
  People as PeopleIcon,
  VideoLibrary as VideoLibraryIcon,
} from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Container,
  CssBaseline,
  Grid,
  Toolbar,
  Typography,
} from '@mui/material'
import Board from 'components/Board'
import React, { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router'
import { DashboardActions, DashboardStoreStates } from '.'
import { Paper } from './styles'

type OwnProps = {}

type DashboardProps = OwnProps & DashboardStoreStates & DashboardActions

const Dashboard = (props: DashboardProps) => {
  const { notifications, users, loadNotifications, loadUsers } = props
  const [expandedId, setExpandedId] = useState<string | null>(null)

  const numberOfMovies = users.items.reduce((count, user) => count + user.numberOfMovies, 0)

  useEffect(() => {
    // お知らせ一覧の読み込み
    if (!notifications.loading && !notifications.loaded) loadNotifications()
    // ユーザ一覧の読み込み
    if (!users.loading && !users.loaded) loadUsers()
  }, [])

  return (
    <Container>
      <CssBaseline />
      <Paper>
        <Toolbar>
          <Grid size="grow">
            <Typography variant="h4">最新のお知らせ</Typography>
          </Grid>
          <Grid>
            <Button variant="outlined" color="primary" component={RouterLink} to="/notifications">
              全てのお知らせを見る
            </Button>
          </Grid>
        </Toolbar>

        {notifications.items.length === 0 && <Typography variant="h6">現在お知らせはありません</Typography>}

        {notifications.items.slice(0, 3).map((row) => (
          <Accordion
            key={row.id}
            expanded={expandedId === row.id}
            onChange={() => setExpandedId(row.id === expandedId ? null : row.id)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid
                container
                sx={{
                  alignItems: 'center',
                }}>
                <Typography sx={{ width: 200 }}>{row.updatedDate}</Typography>
                <Typography sx={{ fontWeight: 'bold' }}>{row.title}</Typography>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{row.content}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Paper>
      <Paper>
        <Toolbar>
          <Grid size="grow">
            <Typography variant="h4">各種データ</Typography>
          </Grid>
        </Toolbar>

        <Grid container>
          <Grid>
            <Board
              title="ユーザー数"
              description={`${users.items.length} 人`}
              icon={<PeopleIcon style={{ fontSize: 50 }} />}
            />
          </Grid>
          <Grid>
            <Board
              title="投稿数"
              description={`${numberOfMovies}`}
              icon={<VideoLibraryIcon style={{ fontSize: 50 }} />}
            />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  )
}

export default Dashboard
